import { createContext } from 'react';

export const FormikRefContext = createContext<any>(null);
